"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrimaryAddressLocation = void 0;
var _usePrimaryAddressQuery = require("../api/usePrimaryAddressQuery");
var _logger = require("../logger");
var _useGeocodingSearch = require("./useGeocodingSearch");
const hookName = 'usePrimaryAddressLocation';
const usePrimaryAddressLocation = ({
  isActive,
  onSuccess
}) => {
  if (isActive) {
    (0, _logger.logDebug)(`${hookName} hook called. Params:`, {
      isActive,
      onSuccess
    });
  }
  const {
    isPrimaryAddressLoading: isStep1Loading,
    primaryAddress
  } = (0, _usePrimaryAddressQuery.usePrimaryAddressQuery)(isActive);

  // TO-DO: There is now a bug in the /system/ajax/DeliverySelection/GetPrimaryAddress endpoint.
  // It returns the more detailed data in the city property, less detailed generic data in address.
  // This should be swapped & then also the props used here in step 2 & 3.
  const isStep2Active = Boolean(primaryAddress?.city) && !isStep1Loading;
  const {
    foundPosition: step2Result,
    isGeocodingLoading: isStep2Loading
  } = (0, _useGeocodingSearch.useGeocodingSearch)({
    isActive: isStep2Active,
    maxResultsCount: 1,
    onSuccess,
    searchTerm: primaryAddress?.city ?? ''
  });
  const isStep3Active = Boolean(primaryAddress?.address) && !isStep1Loading && !isStep2Loading && !step2Result;
  const {
    foundPosition: step3Result,
    isGeocodingLoading: isStep3Loading
  } = (0, _useGeocodingSearch.useGeocodingSearch)({
    isActive: isStep3Active,
    maxResultsCount: 1,
    onSuccess,
    searchTerm: primaryAddress?.address ?? ''
  });
  if (isActive) {
    (0, _logger.logDebug)(`${hookName} hook data:`, {
      isStep1Loading,
      isStep2Loading,
      isStep3Loading,
      isStep2Active,
      isStep3Active,
      primaryAddress,
      step2Result,
      step3Result
    });
  }
  return {
    isPrimaryAddressLoading: isStep1Loading || isStep2Loading || isStep3Loading,
    primaryAddress,
    primaryAddressLocation: step2Result ?? step3Result ?? undefined
  };
};
exports.usePrimaryAddressLocation = usePrimaryAddressLocation;